import { useState } from 'react'
import { Card, CardContent, CardHeader } from '@/common/ui/card'
import { Button } from '@/common/ui/button'
import { Plus } from 'lucide-react'
import { useQueryStates, parseAsInteger } from 'nuqs'
import { QuotaHistoryTable } from '../QuotaHistoryTable'
import { PurchaseQuotaDialog } from '../PurchaseQuotaDialog'
import { useQueryGetQuotaPurchaseHistory } from '../../api/hooks/useQueryGetQuotaPurchaseHistory'

export function QuotaHistoryListing() {
	const [showPurchaseDialog, setShowPurchaseDialog] = useState(false)

	const [queryParams] = useQueryStates({
		page: parseAsInteger.withOptions({ shallow: false }).withDefault(1),
		limit: parseAsInteger.withOptions({ shallow: false }).withDefault(10),
	})

	const query = {
		take: queryParams.limit,
		skip: (queryParams.page - 1) * queryParams.limit,
	}

	const { data, isLoading } = useQueryGetQuotaPurchaseHistory(query)

	return (
		<>
			<Card>
				<CardHeader>
					<div className="flex items-center justify-between">
						<h2 className="text-xl font-semibold">ประวัติการซื้อโควต้า</h2>
						<Button onClick={() => setShowPurchaseDialog(true)}>
							<Plus className="mr-2 h-4 w-4" />
							ซื้อโควต้า
						</Button>
					</div>
				</CardHeader>
				<CardContent>
					<QuotaHistoryTable
						data={data?.data ?? []}
						totalItems={data?.total ?? 0}
						isLoading={isLoading}
					/>
				</CardContent>
			</Card>

			<PurchaseQuotaDialog
				open={showPurchaseDialog}
				onOpenChange={setShowPurchaseDialog}
			/>
		</>
	)
}
